import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { CustomTypoH3, CustomTypoH6Gray } from '../helper/headings';
import '../styles/components.css';

const BusinessSeriesCard = ({ image, date, des, spotify, apple, google, youtube }) => {
    const openSpotifyLink = () => window.open(spotify, "_blank");
    const openApplePodcastLink = () => window.open(apple, "_blank");
    const openGooglePodcastLink = () => window.open(google, "_blank");
    const openYoutubeLink = () => window.open(youtube, "_blank");
    return (
        <Card sx={{ maxWidth: 360 }} className='business_card'>
            <CardMedia
                component="img"
                width={'319px'}
                height={'306px'}
                image={image}
                alt="card-snaps"
                className='card__image'
            />
            <CardContent sx={{ paddingX: 0 }}>
                <div className='date-grid nb-nlp'>
                    <CalendarMonthOutlinedIcon sx={{ color: '#655F5F' }} />
                    <h5>{date}</h5>
                </div>
                <CustomTypoH3 typo={des} />
                <CustomTypoH6Gray typo={'Listen on'} />

                <div className='business-card-image-list'>
                    <img src={require('../assets/Ellipse17-CardBS.png')} alt="Ellipse17-CardBS" onClick={openSpotifyLink} />
                    <img src={require('../assets/Ellipse18-CardBS.png')} alt="Ellipse18-CardBS" onClick={openApplePodcastLink} />
                    <img src={require('../assets/Ellipse19-CardBS.png')} alt="Ellipse19-CardBS" onClick={openGooglePodcastLink} />
                    <img src={require('../assets/Ellipse20-CardBS.png')} alt="Ellipse20-CardBS" onClick={openYoutubeLink} />
                </div>
            </CardContent>
        </Card>
    );
};

export default BusinessSeriesCard;